import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import './App.css';
import './config/emailjs'; // Initialize EmailJS
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Capabilities from './components/Capabilities';
import WhyChooseUs from './components/WhyChooseUs';
import Services from './components/Services';
import BookingModal from './components/BookingModal';
import Footer from './components/Footer';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Navigation />
        <Hero />
        <Capabilities />
        <WhyChooseUs />
        <Services />
        {/* <Testimonials /> */}
        <BookingModal />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
